<template>
	<base-layout>
		<template slot="page-header-right">
			<ul>
				<!--li>
					<a @click="debug">debug</a>
				</li-->
				<li>
					<button v-if="!hideLoginButton" type="button" class="btn btn-primary tests_login_main_action" @click="login"><i class="fa fa-fw fa-lock"></i> Sign in / Sign up</button>
				</li>
			</ul>
		</template>

		<template slot="page-content">
			<slot name="page-content">
				--page-content--
			</slot>
		</template>
	</base-layout>
</template>

<script>
const auth = require("@/utils/auth");
import router from "@/router";

export default {
  name: "unauth-layout",
  props:['hideLoginButton'],
  data() {
    return {};
  },
  methods: {
    login() {
      return auth.login("/namespaces");
    },
    debug() {
      return debug();
    }
  }
};
</script>

<style scoped>
.row {
  margin: 0;
}
#top-nav {
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
}
a {
  text-decoration: underline;
}
#top-nav ul {
  margin: 0;
  height: 100%;
  display: flex;
  align-items: center;
  float: right;
  padding: 0;
}
#top-nav li {
  display: inline;
  list-style-type: none;
  margin-left: 10px;
}
.header-title svg {
  width: 30px;
  fill: rgb(51, 51, 51);
}
.header-title h1 {
  /*background: url("../assets/images/logo5.svg") no-repeat left center;
  background-size: 25px 25px;*/
  font-size: 2em;
  margin: 10px;
  display: flex;
  align-items: center;
}
.header-title h1 span {
  margin: 10px 0 10px 11px;
  font-weight: bold;
}
.header-nav {
  text-align: right;
  padding: 10px 40px 10px 0;
}
a:hover {
  cursor: pointer;
}
#main {
  text-align: center;
}
h3 {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UnauthenticatedLayout.vue